// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UwMU","textarea":"styles_textarea__1kHzW"};